import Actions                  from 'Redux/Actions';
import { OrganizerRepository }  from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateOrganizerEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateOrganizerRequest.type),
    mergeMap(action => from(OrganizerRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((organizer) => {
          message.success('Die Speicherung des Organisators erfolgreich.');

          return from([
            Actions.updateOrganizerSuccess({ organizer }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateOrganizerFailure({ error })
          ]);
        })
      )
    ),
  );
};
